<!-- SPDX-License-Identifier: GPL-3.0-or-later -->
<script lang="ts">
  import type { Snippet } from 'svelte';

  interface Props {
    header: Snippet;
    body: Snippet;
    controls: Snippet;
    errorBanner?: Snippet;
    emptyState?: Snippet;
  }

  let { header, body, controls, errorBanner, emptyState }: Props = $props();
</script>

<div
  class="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-indigo-950 pb-32 relative overflow-hidden"
>
  <div
    class="absolute top-0 -left-20 w-72 h-72 bg-indigo-500/10 rounded-full blur-3xl pointer-events-none"
  ></div>
  <div
    class="absolute bottom-0 -right-20 w-72 h-72 bg-purple-500/10 rounded-full blur-3xl pointer-events-none"
  ></div>

  <div class="max-w-5xl mx-auto p-4 md:p-6 relative z-10">
    {@render header()}
    {#if errorBanner}
      <div class="mb-4">{@render errorBanner()}</div>
    {/if}
    {#if emptyState}
      <div class="mb-6">{@render emptyState()}</div>
    {/if}
    {@render body()}
  </div>

  {@render controls()}
</div>
